import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function AdminLoginPage() {
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { username, password });
      toast.success("Giriş başarılı");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center gradient-primary-soft p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Logo /></div>
        <form onSubmit={submit} className="rounded-3xl bg-white border border-ink-100 p-8 brand-shadow">
          <h1 className="font-display font-black text-3xl text-ink-900">Yönetim Paneli</h1>
          <p className="mt-1 text-ink-500">Sadece yetkili kullanıcılar için</p>
          <div className="mt-6 space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-widest text-ink-500 font-bold">Kullanıcı Adı</Label>
              <div className="relative mt-1.5">
                <User className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-500" />
                <Input data-testid="admin-username" value={username} onChange={(e) => setUsername(e.target.value)} className="pl-9 rounded-xl border-ink-100 focus-visible:ring-brand-500" required />
              </div>
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-ink-500 font-bold">Şifre</Label>
              <div className="relative mt-1.5">
                <Lock className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-ink-500" />
                <Input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="pl-9 rounded-xl border-ink-100 focus-visible:ring-brand-500" required />
              </div>
            </div>
            <Button data-testid="admin-login-submit" disabled={loading} type="submit" className="w-full gradient-primary text-white rounded-full h-12 font-bold uppercase text-sm tracking-wider">
              <LogIn className="h-4 w-4 mr-2" /> {loading ? "Giriş..." : "Giriş Yap"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
